import React from 'react';

import MuiChip from '@mui/material/Chip';

/**
 * master/type API で取得した項目を Chip 表示する際に、
 * 配列の index 番号ごとに色を固定するためのカラーパレット。
 * 全画面で統一的な色表示を実現する。
 */
const INDEX_COLORS: string[] = [
  '#1976d2', // blue
  '#388e3c', // green
  '#f57c00', // orange
  '#7b1fa2', // purple
  '#d32f2f', // red
  '#00796b', // teal
  '#5d4037', // brown
  '#303f9f', // indigo
  '#c2185b', // pink
  '#0097a7', // cyan
  '#689f38', // light green
  '#fbc02d', // yellow
  '#455a64', // blue grey
  '#e64a19', // deep orange
  '#512da8', // deep purple
];

/**
 * index からカラーを取得する。パレットを超えた場合はループする。
 */
export const getIndexColor = (index: number): string => {
  return INDEX_COLORS[index % INDEX_COLORS.length];
};

type MasterTypeChipProps = {
  /** 表示ラベル */
  label: string;
  /** 配列内での index（色を決定するために使用） */
  colorIndex: number;
  /** サイズ */
  size?: 'small' | 'medium';
  /** バリアント */
  variant?: 'filled' | 'outlined';
  /** クリックハンドラ */
  onClick?: () => void;
};

/**
 * master/type API で取得した区分値を Chip 表示するコンポーネント。
 * 配列の index ごとに色が固定され、全画面で色の統一が保証される。
 */
const MasterTypeChip: React.FC<MasterTypeChipProps> = ({
  label,
  colorIndex,
  size = 'small',
  variant = 'outlined',
  onClick,
}) => {
  const color = getIndexColor(colorIndex);

  return (
    <MuiChip
      label={label}
      size={size}
      variant={variant}
      onClick={onClick}
      sx={{
        color: variant === 'outlined' ? color : '#fff',
        borderColor: color,
        backgroundColor: variant === 'filled' ? color : undefined,
        cursor: onClick ? 'pointer' : 'default',
        fontWeight: 400,
        height: size === 'small' ? 20 : undefined,
        fontSize: size === 'small' ? '0.7rem' : undefined,
      }}
    />
  );
};

export default MasterTypeChip;
